import React, { useEffect, useState } from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import { PrevBtn, NextBtn, PaginationWrapper } from "../Styles/PageStyles";
import Images from "../../Images";
import tw from "tailwind-styled-components";
import { PaginationLimit } from "../../Config";
import moment from "moment";
import { MdDelete } from "react-icons/md";
import { IoMdMore } from "react-icons/io";
import { getModeName, handleCopy } from "../../helpers";
import { GoDownload } from "react-icons/go";
import { IoCopySharp } from "react-icons/io5";

const Table = ({ ApiData, setSelectedData, setDeleteModal }) => {
  const [data, setData] = useState([
    {
      deviceName: "",
      extractionTime: "",
      processingTime: "",
      drops: "",
    },
  ]);

  const [selectedRow, setSelectedRow] = useState(null);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);
  const [previousId, setPreviousId] = useState(null);
  const [currentPage, setCurrentPage] = useState(0);
  const [openActionMenu, setOpenActionMenu] = useState(null);

  const toggleRow = (index) => {
    setSelectedRow(selectedRow === index ? null : index);
  };

  useEffect(() => {
    if (ApiData) {
      const tempData = ApiData.map((item) => ({
        tenantName: tenantName(item),
        collectionDate: getDate(item),
        amount: getAmount(item),
        mode: getMode(item),
        transactionFor: getTransactionFor(item.transactionFor),
        receipt: ActionBtns(item),
        clientName: clientpropName(item),
        tenantMobile: item.tenantMobile,
      }));
      setData(tempData);
    }
  }, [ApiData, openActionMenu]);

  const tenantName = (item) => {
    return (
      <div className="flex flex-col gap-[2px]">
        <UserImageWrapper>
          <UserImage
            src={Images.Avatar}
            alt={`Avatar for ${item.tenantName}`}
          />
          <div className="flex flex-col gap-1">
            <p className="text-zinc-900 font-medium">
              {item.tenantName}{" "}
            </p>
           <div className="flex items-center gap-1 text-xs text-gray-400">
              <p className="text-amber-500 text-xs">#{item.tenantMobile}</p>
              <button
                  onClick={(e) => {
                    e.stopPropagation();
                    handleCopy(item.tenantMobile);
                  }}
                  className="hover:text-gray-600 transition"
                  title="Copy number"
                >
                  <IoCopySharp size={8} />
              </button>
           </div>
          </div>
        </UserImageWrapper>
      </div>
    );
  };

  const clientpropName = (item) => {
    return (
      <div className="flex flex-col gap-[2px]">
        <div className="flex flex-col gap-1">
          <span className="text-zinc-600 font-medium max-w-[120px] truncate cursor-pointer" title={item.propName}>{item.propName} </span>
          <span className="text-zinc-500 text-xs">{item.clientName}</span>
        </div>
      </div>
    );
  };

  const getTransactionFor = (transactionFor) => {
    if (transactionFor === 0) {
      return (
        <div className="flex items-center gap-2">
          <h2>Initial Settlement</h2>
        </div>
      );
    } else if (transactionFor === 1) {
      return (
        <div className="flex items-center gap-2">
          <h2>RENT</h2>
        </div>
      );
    } else if (transactionFor === 2) {
      return (
        <div className="flex items-center gap-2">
          <h2>SECURITY</h2>
        </div>
      );
    } else if (transactionFor === 3) {
      return (
        <div className="flex items-center gap-2">
          <h2>MAINTENANCE</h2>
        </div>
      );
    } else if (transactionFor === 4) {
      return (
        <div className="flex items-center gap-2">
          <h2>ELECTRICITY</h2>
        </div>
      );
    } else if (transactionFor === 5) {
      return (
        <div className="flex items-center gap-2">
          <h2>REGISTRATION</h2>
        </div>
      );
    } else if (transactionFor === 6) {
      return (
        <div className="flex items-center gap-2">
          <h2>TECH CHARGES</h2>
        </div>
      );
    } else if (transactionFor === 7) {
      return (
        <div className="flex items-center gap-2">
          <h2>OTHER</h2>
        </div>
      );
    } else if (transactionFor === 8) {
      return (
        <div className="flex items-center gap-2">
          <h2>AGREEMENT CHARGE</h2>
        </div>
      );
    } else if (transactionFor === 9) {
      return (
        <div className="flex items-center gap-2">
          <h2>FOOD</h2>
        </div>
      );
    } else if (transactionFor === 10) {
      return (
        <div className="flex items-center gap-2">
          <h2>FINE</h2>
        </div>
      );
    } else if (transactionFor === 11) {
      return (
        <div className="flex items-center gap-2">
          <h2>SETTLEMENT</h2>
        </div>
      );
    } else if (transactionFor === 12) {
      return (
        <div className="flex items-center gap-2">
          <h2>WIFI</h2>
        </div>
      );
    } else if (transactionFor === 13) {
      return (
        <div className="flex items-center gap-2">
          <h2>GAS</h2>
        </div>
      );
    } else if (transactionFor === 14) {
      return (
        <div className="flex items-center gap-2">
          <h2>MAID CHARGES</h2>
        </div>
      );
    } else if (transactionFor === 15) {
      return (
        <div className="flex items-center gap-2">
          <h2>DAMAGE</h2>
        </div>
      );
    } else if (transactionFor === 16) {
      return (
        <div className="flex items-center gap-2">
          <h2>KEY CHARGES</h2>
        </div>
      );
    } else if (transactionFor === 17) {
      return (
        <div className="flex items-center gap-2">
          <h2>LAUNDRY CHARGES</h2>
        </div>
      );
    }
  };

  const getMode = (item) => {
    return (
      <div className="flex flex-col gap-1">
        <span className="text-gray-600 font-medium text-[13px]">
          {getModeName(item.mode)}
        </span>
        {item.recordedBy && (
          <span
            className={`text-xs ${item.recordedBy === "Kipinn App" ? "text-blue-500" : "text-gray-400"}`}
          >
            {"Recorded By " + item.recordedBy}
          </span>
        )}
      </div>
    );
  };

  const GATEWAY_MAP = {
    1: "PAYU",
    2: "Cashfree",
    3: "Easebuzz",
  };

  const gatewayStyles = {
    PAYU: "bg-blue-100 text-blue-700 border-blue-200",
    Cashfree: "bg-emerald-100 text-emerald-700 border-blue-200",
    Easebuzz: "bg-violet-100 text-violet-700 border-violet-200",
  };

  const getAmount = (item) => {
    const gatewayValue = Number(item.gateway);

    const gatewayName = GATEWAY_MAP[gatewayValue] || "";

    return (
      <div className="flex flex-col gap-1">
        <span className="text-zinc-600 font-medium">
          ₹ {Number(item.amount).toLocaleString("en-IN")}
        </span>

        { gatewayName && (<div
          className={`px-1.5 py-0.1 rounded-full text-[8px] font-semibold border w-fit shadow-sm tracking-wide uppercase
          ${gatewayStyles[gatewayName]}
        `}
        >
          {gatewayName}
        </div>)}
      </div>
    );
  };

  const getDate = (item) => {
    return (
      <div className="flex flex-col">
        <div className="flex flex-col">
          <span className="text-zinc-600 font-medium">{moment(item.collectionDate).format("DD-MMM-YY")}</span>
          <span className="text-zinc-500 text-xs">{moment(item.collectionDate).format("HH:mm:ss")}</span>
        </div>
      </div>
    );
  };
  
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        !event.target.closest("#menuOptions") &&
        !event.target.closest(".action-btn")
      ) {
        setOpenActionMenu(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const deleteTran = (item) => {
    setDeleteModal(true);
    setSelectedData(item);
    setOpenActionMenu(null);
  };

  const download = (receipt) => {
    window.open(receipt, "_blank");
  };

  const ActionBtns = (item) => {
    const openMenu = (id) => {
      setPreviousId(openActionMenu);
      setOpenActionMenu((prevId) => {
        return prevId === id ? null : id;
      });
    };

    return (
      <ActionBtnWrapper>
        {openActionMenu === item.id && (
          <MenuOptions id="menuOptions">
            <MenuItem title="Delete Tenants" onClick={() => deleteTran(item)}>
              <MdDelete className="text-gray-800 mr-2" /> Delete
            </MenuItem>
            <MenuItem title="Download" onClick={() => download(item.receipt)}>
              <GoDownload className="text-gray-800 mr-2" /> Download
            </MenuItem>
          </MenuOptions>
        )}
        <Btn title="Actions" type="button" onClick={() => openMenu(item.id)}>
          <IoMdMore className="text-gray-600" size={24} />
        </Btn>
      </ActionBtnWrapper>
    );
  };

  const DownloadBtn = (item) => {
    return (
      <div className="flex gap-4 ">
        <button onClick={() => download(item.receipt)}>
          <GoDownload size={16} />
        </button>
      </div>
    );
  };
  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const columns = React.useMemo(() => {
    if (isMobileView) {
      return [
        {
          Header: "Owner Name",
          accessor: "tenantName",
        },
        {
          Header: "Amount",
          accessor: "amount",
        },
      ];
    }
    return [
      {
        Header: "Tenant",
        accessor: "tenantName",
      },
      {
        Header: "Amount",
        accessor: "amount",
      },
      {
        Header: "Property/Client",
        accessor: "clientName",
      },

      {
        Header: "Desc",
        accessor: "transactionFor",
      },
      {
        Header: "Mode",
        accessor: "mode",
      },
      {
        Header: "Date",
        accessor: "collectionDate",
      },
      {
        Header: "receipt",
        accessor: "receipt",
      },
    ];
  }, [isMobileView]);
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    pageOptions,
    page,
    state: { pageIndex },
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
  } = useTable(
    {
      data,
      columns,
      initialState: { pageIndex: currentPage, pageSize: PaginationLimit },
    },
    useSortBy,
    usePagination,
  );

  useEffect(() => {
    setCurrentPage(pageIndex);
  }, [pageIndex]);

  return (
    <>
      <CustomTable {...getTableProps()}>
        <Thead>
          {headerGroups.map((headerGroup) => (
            <Tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <Th {...column.getHeaderProps(column.getSortByToggleProps())}>
                  {column.render("Header")}
                  <span>
                    {column.isSorted ? (
                      <img
                        src={Images.Arrow}
                        alt="down arrow"
                        className={`${
                          column.isSortedDesc ? "-rotate-90" : "rotate-90"
                        } w-1.5 inline-block ml-1.5`}
                      />
                    ) : (
                      ""
                    )}
                  </span>
                </Th>
              ))}
            </Tr>
          ))}
        </Thead>
        <Tbody {...getTableBodyProps()} hasData={ApiData?.length > 0}>
          {page.map((row, rowIndex) => {
            prepareRow(row);
            return (
              <React.Fragment key={rowIndex}>
                <Tr {...row.getRowProps()} hasData={ApiData?.length > 0}>
                  {row.cells.map((cell, cellIndex) => {
                    return (
                      <Td
                        {...cell.getCellProps()}
                        onClick={() => {
                          if (
                            cellIndex === 0 ||
                            (cellIndex === 1 && window.innerWidth < 768)
                          ) {
                            toggleRow(rowIndex);
                          }
                        }}
                      >
                        {cell.render("Cell")}
                      </Td>
                    );
                  })}
                </Tr>
                {selectedRow === rowIndex && window.innerWidth < 768 && (
                  <Tr>
                    <Td colSpan={columns.length}>
                      <ul className="flex flex-col gap-2">
                        <li>
                          <strong>Transaction:</strong>{" "}
                          {data[rowIndex].transactionFor}
                        </li>
                        <li className="flex gap-2">
                          <strong>Status:</strong> {data[rowIndex].status}
                        </li>
                        <li>
                          <strong>Action:</strong> {data[rowIndex].action}
                        </li>
                      </ul>
                    </Td>
                  </Tr>
                )}
              </React.Fragment>
            );
          })}
        </Tbody>
      </CustomTable>
      {ApiData?.length > 0 && (
        <PaginationWrapper>
          <div className="px-2">
            Page{" "}
            <em>
              {pageIndex + 1} of {pageOptions.length}
            </em>
          </div>

          <div className="flex gap-1">
            <PrevBtn onClick={() => previousPage()} disabled={!canPreviousPage}>
              <img src={Images.Arrow} alt="arrow" className="w-2 opacity-75 " />
            </PrevBtn>
            <NextBtn onClick={() => nextPage()} disabled={!canNextPage}>
              <img
                src={Images.Arrow}
                alt="arrow"
                className="w-2 rotate-180 opacity-75"
              />
            </NextBtn>
          </div>
        </PaginationWrapper>
      )}
    </>
  );
};

const MenuOptions = tw.div`absolute bottom-10 right-0 py-4 w-max bg-white z-50 rounded-lg shadow-lg border border-gray-200 flex flex-col`;
const MenuItem = tw.div`flex items-center gap-2 px-4 py-2 text-base font-medium cursor-pointer hover:bg-gray-100`;
const Btn = tw.button`action-btn grid place-items-center border border-gray-300 w-8 h-8 rounded-full transform transition duration-200 hover:scale-110 hover:shadow-md`;
const ActionBtnWrapper = tw.div`flex items-center gap-3 relative`;
const CustomTable = tw.table` w-full text-zinc-600`;
const Thead = tw.thead`border-b uppercase text-zinc-500 bg-slate-100`;
const Tbody = tw.tbody`${(props) => (props.hasData ? "border-b" : "")}`;
const Tr = tw.tr`${(props) =>
  props.hasData
    ? "border-b"
    : ""} rounded-md overflow-hidden hover:bg-slate-50`;
const Th = tw.th`text-left text-sm md:p-3 p-0.5 font-medium text-gray-500`;
const Td = tw.td`p-3 text-sm md:p-3 text-left`;
const UserImageWrapper = tw.div` flex items-center gap-2`;
const UserImage = tw.img`w-9 h-9 rounded-full `;

export default Table;
